
  import { Component, Vue } from 'vue-property-decorator';
  import AppDialog from '@/modules/Popup/components/AppDialog.vue';
  import * as emailValidator from 'email-validator';

  @Component({
    components: {
      AppDialog
    }
  })
  export default class ChangeEmailPopup extends Vue {
    $refs: any;
    currentPopup = { blockName: 'profile', dialogName: 'changeEmailPopup' };
    dataEmail = {
      password: '',
      newEmail: ''
    };

    get formModel() { return this.dataEmail; }

    formRules = {
      password: [{ required: true, message: 'Укажите пароль', trigger: 'blur' }],
      newEmail: [{
        validator: (rule, value, callback) => emailValidator.validate(value) ? callback() : callback(new Error('Укажите email')),
        message: 'Укажите email',
        trigger: 'blur'
      }]
    };

    onConfirmChangeEmail() {
      this.$refs.formConfirmEmail.validate((valid) => {

        if (valid) {
          this.$store.dispatch('profile/changeEmail', this.dataEmail)
            .then(() => this.$store.dispatch('profile/init'));
        } else {
          return false;
        }
      });
    }

    async onClose() {
      this.$refs.appDialog.onClose();
    }
  }
